/*
  Skip link component to handle in-page navigation and
  set tabIndex attribute for appropriate handling by screen readers
  (some screen readers - i.e. VoiceOver).

  If the tabIndex is not set, VoiceOver will not move focus to the
  target element on mobile devices. See: https://axesslab.com/skip-links/

  IMPORTANT: This is a workaround for a browser/screen-reader bug.
  If the bug is addressed, this component will no longer be needed,
  and skip links should be implemented with basic <a> tags.
  See a related bug report: https://bugs.webkit.org/show_bug.cgi?id=179011

  The target element should not be an element that is
  focusable by default (<input>, <a>, <button>, etc.) because setting the
  tabIndex to -1 makes the element unreachable via keyboard tabbing.
*/
import classnames from "classnames";
import { Component, PropTypes } from "react";

class SkipLink extends Component {

  getTargetElement() {
    return document.getElementsByClassName(this.props.focusElementClass)[0];
  }

  render() {
    const skipLinkNavigation = () => {
      const targetElement = this.getTargetElement();
      if (targetElement) {
        targetElement.setAttribute("tabIndex", "-1");
        targetElement.focus();
      }
    };
    return (
      <a
        className={classnames(this.props.classnames)}
        href={this.props.href}
        onClick={skipLinkNavigation} >
      {this.props.text}
      </a>
    );
  }
}

SkipLink.propTypes = {
  classnames: PropTypes.array,
  focusElementClass: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};

export default SkipLink;
